import { DescriptionListTitleStyle } from '@website-builder/widgets/description-list/model/description-list-title-style';

export class DescriptionListSubtitleStyle extends DescriptionListTitleStyle {
  marginTop = 'uk-margin-remove-top';
  alignment = '';

  static normalize(styles: Partial<DescriptionListSubtitleStyle>): DescriptionListSubtitleStyle {
    const generalStyle = DescriptionListTitleStyle.normalize(styles);
    const pureStyles = new DescriptionListSubtitleStyle();

    Object.assign(pureStyles, generalStyle);

    pureStyles.marginTop = styles.marginTop ?? pureStyles.marginTop;
    pureStyles.alignment = styles.alignment ?? pureStyles.alignment;

    return pureStyles;
  }
}
